// import the required animation functions from the angular animations module
import { trigger, state, animate, transition, style, AnimationTriggerMetadata } from '@angular/animations';

export const fadeInSlowAnimation =
trigger('fadeInSlowAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.6s', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        style({ opacity: 1 }),
        animate('0.6s', style({ opacity: 0 }))
    ]),
]);
